import React from 'react';
import { StyledTransparentButton, ButtonIconWrapper, StyledButton } from './Button.styles';
import Lottie from 'lottie-react';
import loaderAnimation from '../../../assets/gifs/loader.json';

const handleLinkWrapping = (Component, props) => {
  const { title, onClick, disabled, isLoading, icon, className, rightside, type } = props;

  return (
    <Component
      onClick={onClick}
      disabled={disabled || isLoading}
      className={className}
      type={type}
      $rightside={rightside}
      $isLoading={isLoading}
    >
      {icon && !isLoading && <ButtonIconWrapper>{icon}</ButtonIconWrapper>}
      {isLoading ? <Lottie animationData={loaderAnimation} loop /> : title}
      {!isLoading && rightside}
    </Component>
  );
};

export const Button = ({ title, onClick, disabled, isLoading, icon, rightside, className, type }) =>
  handleLinkWrapping(StyledButton, {
    title,
    onClick,
    disabled,
    isLoading,
    icon,
    className,
    type,
    rightside,
  });

export const TransparentButton = ({ title, onClick, disabled, isLoading, icon, className, type }) =>
  handleLinkWrapping(StyledTransparentButton, {
    title,
    onClick,
    disabled,
    isLoading,
    icon,
    className,
    type,
  });
